/* eslint-disable @typescript-eslint/no-unsafe-argument */
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroll-component';
import classNames from 'classnames';
import { SortOrder } from 'antd/lib/table/interface';
import { IContactItem } from '../../interface';
import SmartTable from './SmartTable';

// interface WrapperProps {
//   isDashboard: boolean,
//   newContactAdded: boolean,
//   addToListMode: boolean,
// }

const Wrapper = styled.div`
  height: 100%;
  padding: 0px 8px 0px 0px;
  .loader-wrapper-appear {
    padding: 0px 10px 0 24px;
  }
`;

interface ISortOrder {
  name: SortOrder,
  company: SortOrder,
  personality: SortOrder,
  status: SortOrder
}

type Props = {
  isDashboard?: boolean,
  isSearched: boolean,
  selectAll: boolean;
  contacts: IContactItem[];
  searchedContacts: IContactItem[];
  totalContacts: number;
  loading?: boolean;
  totalSearchContacts: number;
  holdSelectedIds: number[];
  isGlobal?: boolean,
  searchLoading?: boolean,
  refreshLoading?: boolean,
  addToListMode?: boolean;
  isListActive?: boolean;
  disableSelectAll?: boolean;
  excludedContactsIds: number[];
  loadMore: () => void,
  handleSelectContacts: (contact: IContactItem, type?: string, singleSelection?: boolean) => void;
  handleConfirmation: (type: string, isSingleContact: boolean) => void;
  selectDisable?: boolean;
  newContactAdded: boolean;
  updateSortingOrders: (property: keyof ISortOrder) => void;
  updateSortingConfig: (sortBy: string, sortType: string) => void;
  sortOrder: ISortOrder;
  handleSetSelectedContacts: (checked: boolean) => void;
  localSearchTerm?: boolean,
} & typeof defaultProps;

const defaultProps = {
  loading: false,
  isDashboard: false,
  isGlobal: false,
  addToListMode: false,
  isListActive: false,
  disableSelectAll: false,
  selectDisable: false,
  searchLoading: false,
  refreshLoading: false,
  localSearchTerm: false,
};

const ContactsTileTable = function ContactsTileTable(props: Props) {
  // eslint-disable-next-line
  const {
    loading,
    contacts,
    isSearched,
    totalContacts,
    searchedContacts,
    selectAll,
    holdSelectedIds,
    searchLoading,
    isDashboard,
    totalSearchContacts,
    isGlobal,
    addToListMode,
    isListActive,
    disableSelectAll,
    excludedContactsIds,
    loadMore,
    handleSelectContacts,
    handleConfirmation,
    selectDisable,
    newContactAdded,
    updateSortingOrders,
    updateSortingConfig,
    sortOrder,
    refreshLoading,
    handleSetSelectedContacts,
    localSearchTerm,
  } = props;

  const hasMore = isSearched ? searchedContacts?.length < totalSearchContacts : contacts?.length < totalContacts;

  const handleSingleContact = (type: string, contact: IContactItem) => {
    // console.info(contact);
    handleConfirmation(type, true);
    handleSelectContacts(contact, type, true);
  };

  return (
    <Wrapper
      className="contacts-tile-table-wrapper"
    // isDashboard={isDashboard}
    // newContactAdded={newContactAdded}
    // addToListMode={addToListMode}
    >
      <InfiniteScroll
        dataLength={isSearched ? searchedContacts?.length : contacts?.length}
        next={loadMore}
        hasMore={hasMore}
        loader={false}
        height="auto"
        className={classNames('aud-Infinite-scroll contacts-tile-table', {
          emptyState: (totalContacts === 0 && searchedContacts?.length === 0 && contacts?.length === 0) && !loading,
          emptyStateDashboard: isDashboard,
          minFlowShow: totalContacts < 2 || contacts?.length < 2,
        })}
      >
        <SmartTable
          updateSortingOrders={updateSortingOrders}
          updateSortingConfig={updateSortingConfig}
          sortOrder={sortOrder}
          selectDisable={selectDisable}
          loading={loading}
          refreshLoading={refreshLoading}
          isListActive={isListActive}
          contacts={isSearched ? searchedContacts : contacts}
          addToListMode={addToListMode}
          isGlobal={isGlobal}
          selectAll={selectAll}
          disableSelectAll={disableSelectAll}
          excludedContactsIds={excludedContactsIds}
          isSearched={isSearched}
          holdSelectedIds={holdSelectedIds}
          totalContacts={totalContacts}
          handleSetSelectedContacts={handleSetSelectedContacts}
          handleSingleContact={handleSingleContact}
          handleSelectContacts={handleSelectContacts}
          isSearchLoading={searchLoading}
          newContactAdded={newContactAdded}
          localSearchTerm={localSearchTerm}
        // hasMore={hasMore}
        />
      </InfiniteScroll>
    </Wrapper>
  );
};

ContactsTileTable.defaultProps = defaultProps;

export default ContactsTileTable;
